import { render, staticRenderFns } from "./CallsReportComp.vue?vue&type=template&id=3bcb22ee&scoped=true&"
import script from "./CallsReportComp.vue?vue&type=script&lang=js&"
export * from "./CallsReportComp.vue?vue&type=script&lang=js&"
import style0 from "./CallsReportComp.vue?vue&type=style&index=0&id=3bcb22ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb22ee",
  null
  
)

export default component.exports